import React from 'react'
import { Helmet } from "react-helmet";

function LandingHeader() {
    return (
        <>
            <Helmet>
                <script
                    src='//in.fw-cdn.com/30289592/167137.js'
                    chat='false'>
                </script>
            </Helmet>
        </>
    )
}

export default LandingHeader